import {
  DatasetListSchema,
  DatasetReadSchema,
} from 'src/types/api/data/dataset';
import { Modality } from 'src/types/api/data/image';
import { dataApi } from 'src/utils/http';

import { shouldUseV3Api } from './helpers';

export const getDataset = async (
  datasetId: string,
  modality: Modality
): Promise<DatasetReadSchema> => {
  const { data } = await dataApi.get<DatasetReadSchema>(
    `/datasets/${datasetId}/`,
    {
      params: {
        modality: modality.toLowerCase(),
      },
    }
  );

  return data;
};

export const getDatasets = async (
  modality: Modality,
  projectId?: string,
  page?: number,
  pageSize?: number
): Promise<DatasetListSchema> => {
  if (projectId) {
    const useV3 = await shouldUseV3Api(projectId, modality);
    if (useV3) {
      return getV3Datasets(projectId, modality, page, pageSize);
    }
  }
  return getV2Datasets(modality, page, pageSize);
};

export const getV3Datasets = async (
  projectId: string,
  modality: Modality,
  page?: number,
  pageSize?: number
): Promise<DatasetListSchema> => {
  const { data } = await dataApi.get<DatasetListSchema>(
    `/v3/projects/${projectId}/datasets`,
    {
      params: {
        page: page || 1,
        page_size: pageSize,
        fields: ['id', 'name', 'createdAt'],
        modality: modality.toLowerCase(),
      },
    }
  );

  type DatasetListWithResults = DatasetListSchema & {
    results?: unknown[];
  };
  const normalized = data as DatasetListWithResults;
  if (!normalized.datasets && normalized.results) {
    normalized.datasets =
      normalized.results as unknown as DatasetListSchema['datasets'];
  }

  return data;
};

export const getV2Datasets = async (
  modality: Modality,
  page?: number,
  pageSize?: number
): Promise<DatasetListSchema> => {
  const { data } = await dataApi.get<DatasetListSchema>(`/datasets/`, {
    params: {
      page: page || 1,
      page_size: pageSize,
      fields: ['id', 'name', 'createdAt'],
      modality: modality.toLowerCase(),
    },
  });
  return data;
};
